import React from 'react';
import GetUserQuery from './GetUserQuery';

const withUser =
  (Component, queryProps = {}) =>
  // eslint-disable-next-line react/display-name
  (props) =>
    <GetUserQuery {...queryProps}>{({ data: { me: user } }) => <Component user={user} {...props} />}</GetUserQuery>;

export default withUser;
